(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shellback-custom-orders"] && !Shopify.designMode) return;
  try {
    
  var projectField = document.getElementById('sbc-project');
  if (projectField) {
    var projectName = new URLSearchParams(window.location.search).get('project');
    if (projectName) projectField.value = projectName;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shellback-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-gallery-filter]');
    if (!button) return;
    var gallery = button.closest('.sbg');
    var category = button.dataset.galleryFilter;
    gallery.querySelectorAll('[data-gallery-filter]').forEach(function(item) { var active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', active); });
    var visible = 0;
    gallery.querySelectorAll('[data-gallery-item]').forEach(function(item) { var show = category === 'all' || item.dataset.galleryItem === category; item.hidden = !show; if (show) visible += 1; });
    gallery.querySelector('[data-gallery-empty]').hidden = visible !== 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shellback-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sb-slider]').forEach(function(slider){var slides=Array.from(slider.querySelectorAll('[data-sb-slide]'));var dots=Array.from(slider.querySelectorAll('[data-sb-dot]'));var index=0;var paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;var timer;var touchStart=0;function show(next){index=(next+slides.length)%slides.length;slides.forEach(function(slide,i){var active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true')});dots.forEach(function(dot,i){var active=i===index;dot.classList.toggle('is-active',active);if(active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')})}function start(){window.clearInterval(timer);if(!paused)timer=window.setInterval(function(){show(index+1)},7000)}slider.querySelector('[data-sb-prev]').addEventListener('click',function(){show(index-1);start()});slider.querySelector('[data-sb-next]').addEventListener('click',function(){show(index+1);start()});dots.forEach(function(dot){dot.addEventListener('click',function(){show(Number(dot.dataset.sbDot));start()})});slider.querySelector('[data-sb-pause]').addEventListener('click',function(event){paused=!paused;event.currentTarget.setAttribute('aria-pressed',paused?'true':'false');event.currentTarget.setAttribute('aria-label',paused?'Resume featured collection rotation':'Pause featured collection rotation');event.currentTarget.textContent=paused?'▶':'Ⅱ';start()});slider.addEventListener('touchstart',function(event){touchStart=event.changedTouches[0].clientX},{passive:true});slider.addEventListener('touchend',function(event){var distance=event.changedTouches[0].clientX-touchStart;if(Math.abs(distance)>48){show(index+(distance<0?1:-1));start()}},{passive:true});slider.addEventListener('mouseenter',function(){window.clearInterval(timer)});slider.addEventListener('mouseleave',start);start()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shellback-shop"] && !Shopify.designMode) return;
  try {
    
(function(){const shop=document.querySelector('.sbshop');if(!shop)return;const select=shop.querySelector('[data-shop-category]');const search=shop.querySelector('[data-shop-search]');const cards=[...shop.querySelectorAll('[data-shop-item]')];const count=shop.querySelector('[data-shop-count]');const empty=shop.querySelector('[data-shop-empty]');const category=new URLSearchParams(location.search).get('category')||new URLSearchParams(location.hash.slice(1)).get('category');if(category&&[...select.options].some(o=>o.value===category))select.value=category;function update(){const halloweenSection=shop.querySelector('[data-halloween-section]');if(halloweenSection)halloweenSection.hidden=select.value!=='seasonal-ornaments-decorations';if(select.value==='halloween'){window.location.assign('/collections/halloween');return;}if(select.value==='vintage-santa'){window.location.assign('/collections/vintage-santa');return;}let shown=0;const term=search.value.toLowerCase().trim();cards.forEach(card=>{const visible=(select.value==='all'||card.dataset.shopItem.split(' ').includes(select.value))&&card.dataset.shopName.includes(term);card.hidden=!visible;if(visible)shown++;});count.textContent=shown+(shown===1?' product':' products');if(empty)empty.hidden=shown>0;}select.addEventListener('change',update);search.addEventListener('input',update);update();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shellback-suncatcher-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const offer = root.querySelector('[data-offer]');
      const price = root.querySelector('[data-price]');
      const note = root.querySelector('[data-offer-note]');
      const designOne = root.querySelector('[data-design-one]');
      const designTwo = root.querySelector('[data-design-two]');
      const designTwoWrap = root.querySelector('[data-design-two-wrap]');
      const cards = [...root.querySelectorAll('[data-design-card]')];

      const heroImage = root.querySelector('.sbw-suncatcher__finished-image');
      const updateCards = () => {
        cards.forEach((card) => {
          const first = card.dataset.designCard === designOne.value;
          const second = card.dataset.designCard === designTwo.value && !designTwo.disabled;
          card.classList.toggle('is-first', first);
          if (first && heroImage) { const image = card.querySelector('img'); heroImage.src = image.src; heroImage.srcset = image.srcset; heroImage.alt = card.dataset.designCard; }
          card.classList.toggle('is-second', second);
          const firstButton = card.querySelector('[data-pick-one]');
          const secondButton = card.querySelector('[data-pick-two]');
          firstButton.textContent = first ? firstButton.dataset.selectedLabel : firstButton.dataset.label;
          secondButton.textContent = second ? secondButton.dataset.selectedLabel : secondButton.dataset.label;
        });
      };

      const updateOffer = () => {
        const selected = offer.options[offer.selectedIndex];
        const isPair = selected.dataset.pair === 'true';
        price.textContent = selected.dataset.price;
        note.textContent = isPair ? note.dataset.pairNote : note.dataset.singleNote;
        designTwoWrap.hidden = !isPair;
        designTwo.disabled = !isPair;
        designTwo.required = isPair;
        root.querySelectorAll('[data-pick-two]').forEach((button) => { button.hidden = !isPair; });
        updateCards();
      };

      offer.addEventListener('change', updateOffer);
      designOne.addEventListener('change', updateCards);
      designTwo.addEventListener('change', updateCards);
      cards.forEach((card) => {
        card.querySelector('[data-pick-one]').addEventListener('click', () => {
          designOne.value = card.dataset.designCard;
          updateCards();
          designOne.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        card.querySelector('[data-pick-two]').addEventListener('click', () => {
          designTwo.value = card.dataset.designCard;
          updateCards();
          designTwo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      updateOffer();
    };

    document.querySelectorAll('[data-sbw-suncatcher]').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => setup(event.target.querySelector('[data-sbw-suncatcher]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
